import NextLink, { LinkProps } from 'next/link';
import { PropsWithChildren } from 'react';

export interface ILinkProps extends LinkProps {
  id?: string;
  href: string;
  target?: string;
  external?: boolean;
  className?: string;
  title?: string;
  dataTestId?: string;
}

const Link = ({
  id,
  children,
  href,
  target,
  external = false,
  className,
  title,
  dataTestId,
  ...restProps
}: PropsWithChildren<ILinkProps>) => {
  if (external) {
    return (
      <a
        id={id}
        className={className}
        title={title}
        href={href}
        data-testid={dataTestId}
        target={target}
        {...restProps}
      >
        {children}
      </a>
    );
  }

  return (
    <NextLink
      title={title}
      id={id}
      className={className}
      href={href}
      target={target}
      data-testid={dataTestId}
      {...restProps}
    >
      {children}
    </NextLink>
  );
};

export default Link;
